export default "__VITE_ASSET__DXT3pWP2__"